module.exports = __webpack_public_path__ + "img/rush-brand_mark.38ac51da.png";